import React from 'react';

const WorkOrderToInvoice = () => {
  return (
    <div className="work-order-to-invoice">
      <div className="page-header">
        <h2>İş Emri → Fatura</h2>
        <p>İş emirlerini faturaya çevirin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default WorkOrderToInvoice; 